module.exports = __webpack_public_path__ + "img/polygon-banner.1daed2e2.jpg";